import { t } from "i18next";
import { IGenericObject } from "../../../../../components/shared/commonTypes/commonTypes";
import { IQuestion } from "../../question/question/QuestionTypes";

// File upload form values
export interface IFileUploadFormValue {
  question: string;
  validation: string[];
  fileTypes: string[];
}

// File upload modal props
export interface IFileUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (values: IFileUploadFormValue) => void;
  data?: IQuestion | null;
  action: string;
}

// Validation object type
export interface IValidationObject {
  label: string;
  value: string;
}

// Validation object list
export const possibleValidationList: IValidationObject[] = [
  {
    label: t("commonDynamicForm.validations.fieldRequired"),
    value: "required",
  },
];

export const fileTypeMetaDataList: IGenericObject[] = [
  {
    id: "png",
    name: "PNG",
  },
  {
    id: "jpeg_jpg",
    name: "JPEG/JPG",
  },
  {
    id: "pdf",
    name: "PDF",
  },
  {
    id: "doc_docx",
    name: "DOC/DOCX",
  },
  {
    id: "csv",
    name: "CSV",
  },
  {
    id: "xls_xlsx",
    name: "XLS/XLSX",
  },
];

// Map of file type extensions
export const fileTypeExtensionMap: Record<string, string[]> = {
  png: ["png"],
  jpeg_jpg: ["jpeg", "jpg"],
  pdf: ["pdf"],
  doc_docx: ["doc", "docx"],
  csv: ["csv"],
  xls_xlsx: ["xls", "xlsx"],
};
